export default "__VITE_ASSET__TwYTi04u__"